import React from "react";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { useIncomingInvoiceService } from "serviceHooks";

function useIncomingInvoiceTodoHelpers(invoice: WintSuperkollAPIModel.IncomingInvoice, onActionSuccess: () => void) {
  const incomingInvoiceService = useIncomingInvoiceService();
  const [loading, setLoading] = React.useState(false);

  const reloadTodo = (
    onSuccess?: (incomingInvoice: WintSuperkollAPIModel.IncomingInvoice) => void,
    onError?: () => void
  ) => {
    if (invoice) {
      setLoading(true);
      incomingInvoiceService
        .get(invoice.id)
        .then((result) => result.data)
        .then((result) => {
          onSuccess && onSuccess(result);
        })
        .catch(() => {
          onError && onError();
        })
        .finally(() => {
          setLoading(false);
          onActionSuccess();
        });
    }
  };

  const onUpdatePaymentSuccess = (
    values: IncomingInvoiceFormTypes.UpdatePayment,
    onSuccess?: (incomingInvoice: WintSuperkollAPIModel.IncomingInvoice) => void
  ) => {
    reloadTodo(onSuccess);
  };

  return { reloadTodo, onUpdatePaymentSuccess, loading };
}

export default useIncomingInvoiceTodoHelpers;
